import React from 'react';
import { Container, Typography, Box, Grid, List, ListItem, ListItemIcon, Button, ListItemText } from '@mui/material';
import {
  Storefront,
  Inventory,
  AttachMoney,
  TrendingUp,
  Assignment,
  LocalShipping,
  SupportAgent,
  ThumbUp,
  AutoAwesome,
} from '@mui/icons-material';

const AmazonMarchandCenter = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        {/* Welcome Section */}
        <Typography variant="h3" gutterBottom align="center" className="text-main-600 font-bold">
          Amazon Dropshipping Merchant Center
        </Typography>
        <Typography variant="body1" paragraph align="center">
          Our Merchant Center is designed to provide you with all the essential tools and information you need to successfully run your dropshipping business on Amazon. Whether you’re just starting out or scaling your operations, we are here to support your journey.
        </Typography>

        {/* What is Amazon Dropshipping Section */}
        <Typography variant="h4" gutterBottom className="text-main-600 font-bold">
          What is Amazon Dropshipping?
        </Typography>
        <Typography variant="body1" paragraph>
          Amazon dropshipping is a business model where you sell products without holding inventory. Instead, you partner with a supplier who fulfills orders on your behalf. This allows you to focus on sales, marketing, and customer service while your supplier handles storage and shipping.
        </Typography>

        {/* Key Benefits Section */}
        <Typography variant="h5" gutterBottom className="text-main-600 font-bold">
          Key Benefits:
        </Typography>
        <Grid container spacing={4}>
          {keyBenefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box sx={{ p: 2, textAlign: 'center' }}>
                <Box sx={{ fontSize: '3rem', color: 'text-main-600' }}>
                  {benefit.icon}
                </Box>
                <Typography variant="h6" gutterBottom className="text-main-600 font-bold">
                  {benefit.title}
                </Typography>
                <Typography variant="body1">{benefit.description}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        {/* Getting Started Section */}
        <Typography variant="h4" gutterBottom className="text-main-600 font-bold">
          Getting Started with Amazon Dropshipping
        </Typography>
        <List>
          {gettingStartedSteps.map((step, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <Assignment fontSize="small" sx={{ color: 'text-main-600' }} />
              </ListItemIcon>
              <ListItemText primary={step} />
            </ListItem>
          ))}
        </List>

        {/* Optimizing for Success Section */}
        <Typography variant="h4" gutterBottom className="text-main-600 font-bold">
          Optimizing for Success
        </Typography>
        <List>
          {optimizationTips.map((tip, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 30 }}>
                <TrendingUp fontSize="small" sx={{ color: 'text-main-600' }} />
              </ListItemIcon>
              <ListItemText primary={tip} />
            </ListItem>
          ))}
        </List>

        {/* Support & Resources Section */}
        <Typography variant="h4" gutterBottom className="text-main-600 font-bold">
          Support & Resources
        </Typography>
        <Typography variant="body1" paragraph>
          We provide ongoing support to help you grow your Amazon dropshipping business. For additional assistance, contact our Merchant Support Team on our customer service or write to us at{' '}
          <Box component="span" sx={{ fontWeight: 'bold' }}>info@amazondropshipping.com</Box>.
        </Typography>

      
      </Box>
    </Container>
  );
};

// Key Benefits Data
const keyBenefits = [
  {
    icon: <Inventory sx={{ color: 'text-main-600' }} />,
    title: 'No Inventory Management',
    description: 'Focus on sales while suppliers handle storage and shipping.',
  },
  {
    icon: <AttachMoney sx={{ color: 'text-main-600' }} />,
    title: 'Low Upfront Investment',
    description: 'Start your business with minimal capital and scale as you grow.',
  },
  {
    icon: <TrendingUp sx={{ color: 'text-main-600' }} />,
    title: 'Scalability',
    description: 'Easily expand your product range and sales volume.',
  },
  {
    icon: <Storefront sx={{ color: 'text-main-600' }} />,
    title: 'Wide Product Selection',
    description: 'Access a vast range of products to meet customer demands.',
  },
];

// Getting Started Steps Data
const gettingStartedSteps = [
  'Set Up an Amazon Seller Account: Choose between an Individual or Professional plan.',
  'Choose a Niche and Supplier: Select profitable products and partner with reliable suppliers like AliExpress, CJ Dropshipping, or SaleHoo.',
  'List Products on Amazon: Optimize listings with high-quality images, compelling descriptions, and competitive pricing.',
  'Manage Orders and Customer Service: Ensure excellent customer support and compliance with Amazon’s policies.',
];

// Optimization Tips Data
const optimizationTips = [
  'Use Amazon Advertising (PPC) to increase product visibility.',
  'Monitor inventory and pricing to remain competitive.',
  'Leverage customer reviews to build trust and credibility.',
  'Consider automation tools like Oberlo, DSers, or AutoDS for efficiency.',
];

export default AmazonMarchandCenter;